"use strict";exports.__esModule=!0,exports.LIB_NAME=void 0;var LIB_NAME="react-dropdown-select";exports.LIB_NAME="react-dropdown-select";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-dropdown-select/lib/constants.js
// module id = 39
// module chunks = 0